import React, { useState } from 'react';
import useRectificationStore from '../../stores/useRectificationStore';
import styles from './ToolCard.module.css';
import NumberInput from '../ui/NumberInput';
import { useToolManager } from '../../hooks/useToolManager';
import { TOOLS_CONFIG } from '../../constants/tools';
import useEditorStore from '../../stores/useEditorStore';

const GlobalReductionToolCard = () => {
  const globalReductionState = useRectificationStore((state) => state.globalReduction);
  const setGlobalReduction = useRectificationStore((state) => state.setGlobalReduction);
  const isApplied = useRectificationStore((state) => state.isGlobalReductionApplied);
  const undoCommand = useRectificationStore((state) => state.currentGlobalReductionCommand);
  const isAppliedFromDraft = useRectificationStore((state) => state.isGlobalReductionAppliedFromDraft);
  const { resetHistoryUpTo } = useRectificationStore.getState();
  const { run } = useToolManager();
  
  const onApply = () => {
    if (!isApplied) {
      run({ tool: TOOLS_CONFIG.MAIN_PROCESS.RECTIFICATION.main_rectification_global_reduction.id, mode: 'apply' });
    } else if (undoCommand) {
      const { resetHistoryUpTo } = useEditorStore.getState?.() || {};
      if (resetHistoryUpTo) resetHistoryUpTo(undoCommand);
      undoCommand.undo?.();
    }
  };

  const isLoadedFromDraft = isApplied && isAppliedFromDraft;

  // Applied state UI similar to MeasureReductionToolCard applied state
  if (isApplied) {
    return (
      <div className={styles.toolCard}>
        <div className={styles.toolCardHeader}>
          <h3>Global Reduction</h3>
          <p>Global Reduction Applied</p>
        </div>
        <div className="flex flex-col gap-5 items-center mt-5 mb-1 pt-4 border-t border-gray-200">
          <button
            className={`px-2 py-1 rounded-md min-w-20 text-white ${
              isLoadedFromDraft
                ? 'bg-gray-400 cursor-not-allowed opacity-60'
                : 'bg-red-400 cursor-pointer hover:bg-red-500 hover:text-white'
            }`}
            onClick={isLoadedFromDraft ? undefined : onApply}
            disabled={isLoadedFromDraft}
            title={isLoadedFromDraft ? "Cannot unapply global reduction loaded from draft" : "Unapply global reduction"}
          >
            Unapply
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className='flex flex-col absolute left-[10px] top-[10px] gap-3'>
      <div className='bg-white rounded-md p-2 shadow-[0_2px_8px_rgba(0,0,0,0.15)] w-[180px] z-[1000] max-h-[70vh]'>
        <div className={styles.toolCardHeader}>
          <h3>Global Reduction</h3>
        </div>
        
        {/* Value Type Dropdown */}
        <div className='flex flex-col gap-2 items-stretch justify-center mb-3'>
          <select
            value={globalReductionState.valueType}
            onChange={(e) => {
              setGlobalReduction({ valueType: e.target.value, value: 0 });
            }}
            className='px-3 py-2 border border-gray-300 rounded-md bg-white text-sm focus:outline-none'
          >
            <option value="%">Percentage (%)</option>
            <option value="cm">Centimeters (cm)</option>
          </select>
        </div>
        
        <div className='flex flex-col gap-2 items-stretch justify-center mb-1 h-10'>
          {globalReductionState.valueType === '%' && <NumberInput
            // label="Percent"
            min="-100"
            max="100"
            step="0.1"
            unit="%"
            value={globalReductionState.value}
            onChange={(e) => {
              const newValue = parseFloat(e) || 0;
              setGlobalReduction({ value: newValue });
            }}
            disabled={globalReductionState.valueType !== '%'}
          />}
          {globalReductionState.valueType === 'cm' &&   <NumberInput
            // label="cm"
            min="-100"
            max="100"
            step="0.1"
            unit="cm"
            value={globalReductionState.value}
            onChange={(e) => {
              const newValue = parseFloat(e) || 0;
              setGlobalReduction({ value: newValue });
            }}
            disabled={globalReductionState.valueType !== 'cm'}
          />}
        </div>
      </div>
      <div className='flex flex-col justify-between gap-3'>
        <button
          className={`py-1 rounded-md min-w-22 text-white text-lg cursor-pointer bg-violet-600 hover:text-white hover:bg-violet-500`}
          onClick={()=> {
            onApply();
          }}
        >
          Apply
        </button>
        <label className="flex items-center cursor-pointer select-none ml-1">
          <input
            type="checkbox"
            checked={globalReductionState.previewVisible}
            onChange={() => setGlobalReduction({ previewVisible: !globalReductionState.previewVisible })}
            className="sr-only"
          />
          <div className={`w-10 h-6 rounded-full transition-colors duration-200 relative ${globalReductionState.previewVisible ? 'bg-purple-600' : 'bg-gray-300'}`}>
            <div
              className={`absolute top-1 left-1 w-4 h-4 bg-white rounded-full shadow transition-transform duration-200 z-10 ${globalReductionState.previewVisible ? 'translate-x-4' : 'translate-x-0'}`}
            ></div>
          </div>
          <span className={`ml-3 text-sm font-medium ${globalReductionState.previewVisible ? 'text-gray-700' : 'text-gray-700'}`}>
            Show Preview
          </span>
        </label>
      </div>
    </div>
  );
};

export default GlobalReductionToolCard; 